var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;
var totalPrice = 0.0;
var currency="";
var selectedBoards = [];

$(document).ready(function() {
	$('select.roomPickSelect:first option:last').prop('selected', true);
	$('select.roomPickSelect').on('change',function(){
		totalAdult = 0;
		totalChild = 0;
		totalRoomCount = 0;
		totalPrice = 0.0;
		currency="";
		var roomNames = '';
		var boardNames = '';
		selectedBoards = [];
		$(".roomNumValue").val(0);
		$('select.roomPickSelect').each(function(idx,room){
			var roomCount = parseInt($(room).val());
			var roomIndex = $(room).attr("index");
			var boardIndex = $(this).attr("boardIndex");
			if (roomCount > 0) {
				totalPrice += parseFloat($(room).attr('price')) * roomCount;
				roomNames += $(room).attr('roomName') + ' x ' + roomCount + '<br> ';
				boardNames += $(room).attr('boardName') + ' ';
				currency = $(room).attr('currency');
				totalAdult += parseInt($(room).attr('adultCount')) * roomCount;
				totalChild += parseInt($(room).attr('childCount')) * roomCount;
				totalRoomCount += roomCount;
				selectedBoards.push(boardIndex);
				$("[name=selectedBoardIndex]").val(selectedBoards.join());
			}
			$("#roomNum_"+ boardIndex+ "_" + roomIndex).val(roomCount);
		});
		$('#totalPrice').html(totalPrice.toFixed(2) + ' ' + currency);
		$('#perPersonPrice').html((totalPrice / (totalAdult + totalChild)).toFixed(2) + ' ' + currency);
		$('#roomNames').html(roomNames);
		$('#boardNames').html(boardNames);
	}).trigger('change');
	
	$('input.roomPickSelect:first').prop('checked',true);
	$('input.roomPickSelect').on('change',function(){
		totalAdult = 0;
		totalChild = 0;
		totalRoomCount = 0;
		totalPrice = 0.0;
		currency="";
		var roomNames = '';
		var boardNames = '';
		selectedBoards = [];
		$(".roomNumValue").val(0);
		$(".roomSelectValue").val(0);
		var room = $('input.roomPickSelect:checked');
		if (room.length > 0){
			var roomIndex = $(room).attr("index");
			var boardIndex = $(this).attr("boardIndex");
			selectedBoards.push(boardIndex);
			$("[name=selectedBoardIndex]").val(selectedBoards.join());
			$("#roomNum_"+ boardIndex+ "_" + roomIndex).val(1);
			$("#roomSelect_"+ boardIndex+ "_" + roomIndex).val(1);
			totalPrice = parseFloat($(room).attr('price'));
			totalAdult = parseInt($(room).attr('adultCount'));
			totalChild = parseInt($(room).attr('childCount'));
			totalRoomCount = 1;
			currency = $(room).attr('currency');
			roomNames = $(room).attr('roomName') + ' x 1';
			boardNames = $(room).attr('boardName');
		}
		$('#totalPrice').html(totalPrice.toFixed(2) + ' ' + currency);
		$('#perPersonPrice').html((totalAdult + totalChild > 0 ? totalPrice / (totalAdult + totalChild) : 0).toFixed(2) + ' ' + currency);
		$('#roomNames').html(roomNames);
		$('#boardNames').html(boardNames);
	}).trigger('change');
	
	bindDatePicker();
	bindRoomSelector();
	
	$('#datesDetail').daterangepicker({
	  minDate: moment(),
	  minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  locale: {
	    format: 'DD MMM, YYYY'
	  },
	  startDate: $('input[name="checkInDate"]').val().length > 0 ? moment($('input[name="checkInDate"]').val(),'DD.MM.YYYY') : moment(),
	  endDate: $('input[name="checkOutDate"]').val().length > 0 ? moment($('input[name="checkOutDate"]').val(),'DD.MM.YYYY') : moment()
	});
	
	$('#datesDetail').on('apply.daterangepicker', function(ev, picker) {
		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
	});
	$( ".show-photos" ).click(function() {
		$("#photosModal").modal('show');
	});
	

});

function bookHotel() {
  	var numAdult = parseInt($("#numAdult").val());
  	var numChild = parseInt($("#numChild").val());
  	var numRoom = parseInt($("#numRoom").val());
  
  	if (totalAdult < numAdult){
		alert(FmtMessage.getMessage('js.adult.count.less'));
		return;
  	} 
  
  	if (totalChild < numChild){
	  	alert(FmtMessage.getMessage('js.child.count.less'));
	  	return;
  	}

  	if(totalRoomCount > numRoom){
      	alert(FmtMessage.getMessage('js.room.count.invalid'));
      	return;
  	}
  
	$('#loading').modal('show');
  	$("#priceDetailHotelForm").submit();
}

function initMap() {
	var map = new google.maps.Map(document.getElementById("map"), {
		zoom: 12,
		center: hotelMap,
		styles: [
			{
				elementType: "geometry",
			    stylers: [{ color: "#FFFFFF" }],
			},
			{
		      	elementType: "labels.icon",
		      	stylers: [{ visibility: "off" }],
		    },
		    {
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#616161" }],
		    },
		    {
		      	elementType: "labels.text.stroke",
		      	stylers: [{ color: "#ffffff" }],
		    },
		    {
		      	featureType: "administrative.land_parcel",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#bdbdbd" }],
		    },
		    {
		      	featureType: "poi",
		      	elementType: "geometry",
		      	stylers: [{ color: "#eeeeee" }],
		    },
		    {
		      	featureType: "poi",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#757575" }],
		    },
		    {
		      	featureType: "poi.park",
		      	elementType: "geometry",
		      	stylers: [{ color: "#bff1d3" }],
		    },
		    {
		      	featureType: "poi.park",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    },
		    {
		      	featureType: "road",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "road.arterial",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#757575" }],
		    },
		    {
		      	featureType: "road.highway",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "road.highway",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#616161" }],
		    },
		    {
		      	featureType: "road.local",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    },
		    {
		      	featureType: "transit.line",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "transit.station",
		      	elementType: "geometry",
		      	stylers: [{ color: "#eeeeee" }],
		    },
		    {
		      	featureType: "water",
		      	elementType: "geometry",
		      	stylers: [{ color: "#e8f9ff" }],
		    },
		    {
		      	featureType: "water",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    }
	    ]
	});
		  
	var mappin = "/images/edwin/icons/svg/pin-o.svg";
  
	var marker = new google.maps.Marker({
		position: hotelMap,
		map: map,
		icon: mappin,
	});
}

function bindRoomSelector(context) {
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}